module.exports = __webpack_public_path__ + "img/fas-volume.0e66db57.svg";